import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaEye, FaTrash, FaSpinner } from 'react-icons/fa';
import apinode from '../../services/apinode';
import Navbar from '../../components/navbar/navbar.jsx'

const AdDetails = () => {
    // Estado para armazenar os dados do anúncio e controlar o carregamento
    const [ads, setAds] = useState([]);
    const [filteredAds, setFilteredAds] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true); // Estado de carregamento
    const [selectedSellerId, setSelectedSellerId] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const itemsPerPage = 10;

    // Função para buscar os dados do endpoint
    useEffect(() => {
        const fetchAds = async () => {
            setLoading(true); // Inicia o carregamento
            try {
                const response = await apinode.get(`log/anuncios/${localStorage.idconta}`);
                setAds(response.data);
                setFilteredAds(response.data); // Inicializa o filtro com todos os dados
            } catch (error) {
                console.error('Erro ao buscar dados dos anúncios:', error);
            } finally {
                setLoading(false); // Finaliza o carregamento
            }
        };

        fetchAds();
    }, []);

    // Função para filtrar os anúncios pelo título, MLB Anúncio, sellerid e status
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        filterAds(event.target.value, selectedSellerId, selectedStatus);
    };

    const handleSellerIdChange = (event) => {
        setSelectedSellerId(event.target.value);
        filterAds(searchTerm, event.target.value, selectedStatus);
    };

    const handleStatusChange = (event) => {
        setSelectedStatus(event.target.value);
        filterAds(searchTerm, selectedSellerId, event.target.value);
    };

    const filterAds = (searchTerm, sellerId, status) => {
        const filtered = ads.filter(ad =>
            (ad.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                ad.mlbanuncio.toLowerCase().includes(searchTerm.toLowerCase())) &&
            (sellerId ? ad.sellerid === sellerId : true) &&
            (status ? ad.status === status : true)
        );
        setFilteredAds(filtered);
        setCurrentPage(1); // Resetar a página para 1 ao filtrar
    };

    // Função para mudar a página
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Função para obter os anúncios da página atual
    const getCurrentPageAds = () => {
        const indexOfLast = currentPage * itemsPerPage;
        const indexOfFirst = indexOfLast - itemsPerPage;
        return filteredAds.slice(indexOfFirst, indexOfLast);
    };

    // Número total de páginas
    const totalPages = Math.ceil(filteredAds.length / itemsPerPage);

    // Definir o intervalo de páginas a ser exibido
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        if (
            i === 1 ||
            i === totalPages ||
            (i >= currentPage - 2 && i <= currentPage + 2)
        ) {
            pageNumbers.push(i);
        }
    }

    // Obter todos os sellerid e status únicos
    const uniqueSellerIds = [...new Set(ads.map(ad => ad.sellerid))];
    const uniqueStatuses = [...new Set(ads.map(ad => ad.status))];

    return (
        <>
            <Navbar />
            <div className="container mt-page">
                <h1 className="mb-4 text-left" style={{ fontSize: '2rem', color: '#333' }}>Log Anúncio</h1>

                {/* Filtro de pesquisa */}
                <div className="row mb-4">
                    <div className="col-12 col-md-4 mb-2">
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Pesquisar por título ou MLB"
                                value={searchTerm}
                                onChange={handleSearch}
                                style={{ fontSize: '1rem', padding: '0.75rem' }}
                            />
                            <button className="btn btn-primary" style={{ fontSize: '1rem', padding: '0.75rem' }}>
                                Buscar
                            </button>
                        </div>
                    </div>

                    {/* Filtro de Seller ID */}
                    <div className="col-12 col-md-3 mb-2">
                        <select
                            className="form-select"
                            value={selectedSellerId}
                            onChange={handleSellerIdChange}
                            style={{ fontSize: '1rem', padding: '0.75rem' }}
                        >
                            <option value="">Selecione Seller ID</option>
                            {uniqueSellerIds.map((sellerId) => (
                                <option key={sellerId} value={sellerId}>
                                    {sellerId}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Filtro de Status */}
                    <div className="col-12 col-md-3 mb-2">
                        <select
                            className="form-select"
                            value={selectedStatus}
                            onChange={handleStatusChange}
                            style={{ fontSize: '1rem', padding: '0.75rem' }}
                        >
                            <option value="">Selecione Status</option>
                            {uniqueStatuses.map((status) => (
                                <option key={status} value={status}>
                                    {status}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Exibe o ícone de carregamento enquanto os dados estão sendo carregados */}
                {loading ? (
                    <div className="d-flex justify-content-center mt-5">
                        <FaSpinner className="spinner-border text-primary" size={50} />
                    </div>
                ) : (
                    // Tabela de anúncios
                    <div className="table-responsive">
                        <table className="table table-responsive">
                            <thead className="thead-dark">
                                <tr>
                                    <th>Imagem</th>
                                    <th>MLB Anúncio</th>
                                    <th>Titulo</th>
                                    <th>Data e Hora</th>
                                    <th>Seller ID</th>
                                    <th>Status</th>
                                    <th>Situação</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getCurrentPageAds().length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="text-center">Nenhum anúncio encontrado</td>
                                    </tr>
                                ) : (
                                    getCurrentPageAds().map((ad) => (
                                        <tr key={ad.id}>
                                            <td>
                                                <img src={ad.thumbnail} alt={ad.title} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                                            </td>
                                            <td>
                                                <a
                                                    href={`https://www.mercadolivre.com.br/publicaciones/${ad.mlbanuncio}/modificar?callback_url=https://www.mercadolivre.com.br/anuncios/lista?filters=ACTIVE&search=&sort=&page=1`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-link text-decoration-none"
                                                    style={{ fontSize: '1rem' }}
                                                >
                                                    {ad.mlbanuncio}
                                                </a>
                                            </td>
                                            <td>{ad.title}</td>
                                            <td>{new Date(ad.datahora).toLocaleString()}</td>
                                            <td>{ad.sellerid}</td>
                                            <td>{ad.status}</td>
                                            <td>{ad.situacao}</td>
                                            <td className="text-center">
                                                <div className="btn-group" role="group" aria-label="Ações">
                                                    <button
                                                        className="btn btn-sm btn-success"
                                                        title="Visualizar"
                                                        style={{ fontSize: '0.9rem' }}
                                                    >
                                                        <FaEye />
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        title="Deletar"
                                                        style={{ fontSize: '0.9rem' }}
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </div>
                                            </td>

                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                )}

                {/* Paginação compacta */}
                <div className="d-flex justify-content-center mt-4">
                    <nav aria-label="Page navigation">
                        <ul className="pagination pagination-sm rounded-pill">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button
                                    className="page-link text-primary bg-light border-0 rounded-pill shadow-sm"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    aria-label="Previous"
                                >
                                    Anterior
                                </button>
                            </li>
                            {pageNumbers.map((page) => (
                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                    <button
                                        className={`page-link ${currentPage === page ? 'bg-primary text-white' : 'bg-light text-dark'} border-0 rounded-pill shadow-sm`}
                                        onClick={() => handlePageChange(page)}
                                    >
                                        {page}
                                    </button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button
                                    className="page-link text-primary bg-light border-0 rounded-pill shadow-sm"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    aria-label="Next"
                                >
                                    Próxima
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>

            </div>
        </>
    );
};

export default AdDetails;
